// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2WeWb","productName":"Table_productName__cB0Xn"};